import styled from 'styled-components'
import { Props } from './index';

const RedirectionContainer = styled.div<Props>`
  display: flex;
  background: ${(props) =>
  props.background ? props.background : 'white'}
  `
  export { RedirectionContainer }